import IconProvider from "@/components/ui/IconProvider";
import { usePlatformTranslation } from '@/hooks/usePlatformTranslation';

export function ExportFormatInfoSection() {
  const { t } = usePlatformTranslation();

  return (
    <div className="border border-border rounded p-6 space-y-4 bg-muted/30">
      <div className="flex items-start gap-3">
        <IconProvider iconstring="fa-info-circle" size={16} className="text-primary mt-1" />
        <div className="flex-1">
          <h4 className="heading-4">About the Export Format</h4>
          <div className="text-sm text-muted-foreground space-y-2">
            <p>
              The exported JSON files are structured for easy integration into game engines:
            </p>
            <ul className="list-disc list-inside ml-4 space-y-1">
              <li><strong>{t('platform.settings.importexportsection.complete_export')}</strong> Contains all data in one file with a metadata header</li>
              <li><strong>{t('platform.settings.importexportsection.individual_exports')}</strong> Contain only the specific data type as an array</li>
              <li><strong>{t('platform.settings.importexportsection.relationships')}</strong> Include IDs linking related entities together</li>
              <li><strong>{t('platform.settings.importexportsection.timestamps')}</strong> All items include creation and update timestamps</li>
              <li><strong>{t('platform.settings.importexportsection.identifiers')}</strong> Unique IDs for referencing items across your game</li>
            </ul>
            <p className="mt-4">
              The data is ready to be parsed and used in Unity, Unreal Engine, Godot, or any custom game engine.
            </p>
          </div>
        </div>
      </div>
    </div>
  );
}
